import React from "react"
import { motion } from "framer-motion"
import { FaSpa, FaLeaf, FaHeart } from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"

export default function MissionSection() {
  const items = [
    {
      id: 1,
      icon: <FaSpa />,
      title: "Notre Mission",
      text: "Offrir une expérience de spa de luxe qui favorise la détente, le bien-être et l'équilibre intérieur pour chaque client.",
    },
    {
      id: 2,
      icon: <FaLeaf />,
      title: "Notre Vision",
      text: "Devenir une destination de bien-être de premier plan, reconnue pour son excellence, son confort et ses soins holistiques.",
    },
    {
      id: 3,
      icon: <FaHeart />,
      title: "Nos Valeurs",
      text: "Nous accordons une grande importance à la qualité, à l'attention portée aux détails, au professionnalisme et à un engagement profond envers la satisfaction et le bien-être de nos clients.",
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          subtitle="Qui Sommes Nous"
          title="Notre Mission, Vision & Valeurs"
          description="Nous croyons en la création d'une oasis de paix où le bien-être rencontre le luxe et où chaque détail compte."
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="group bg-white rounded-[30px] p-8 shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#b8955d] text-white text-2xl shadow-md">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-semibold text-[#111111] mt-6">
                {item.title}
              </h3>

              {/* Text */}
              <p className="text-gray-600 leading-relaxed mt-4 text-sm md:text-base">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}